import React, { FC } from 'react';

import NavLink from 'components/app-header/nav-link';
import { INavigationLinkFragment } from 'generated/sanity-graphql';
import useRoutes from 'hooks/use-routes';
import { useStoreContext } from 'state/store';

import { IDynamicLeftNavContainerProps, IValidDesktopLink, IValidNavLink } from './types';

export const DynamicLeftNavContainer: FC<IDynamicLeftNavContainerProps> = ({ navLinks }) => {
  const { store } = useStoreContext();
  const { getLocalizedRouteForPath } = useRoutes();

  const determinePath = (navLink: IValidNavLink): string => {
    // if order link and restaurant already selected go to '/menu otherwise go to store-locator
    return navLink.text !== 'order' || store.hasSelection
      ? navLink.link
      : getLocalizedRouteForPath('store-locator');
  };

  const isValidLink = (link: INavigationLinkFragment | null): link is IValidDesktopLink => {
    return !!(link?._key && link?.navLink?.link?.locale && link?.navLink?.text?.locale);
  };

  const validNavLinks = navLinks.reduce<IValidNavLink[]>((acc, val) => {
    if (isValidLink(val)) {
      acc.push({ key: val._key, link: val.navLink?.link?.locale, text: val.navLink?.text?.locale });
    }
    return acc;
  }, []);

  return (
    <>
      {validNavLinks.map(navLink => (
        <NavLink
          key={navLink.key}
          data-testid={navLink.text}
          to={determinePath(navLink)}
          matchRoute={navLink.link}
        >
          {navLink.text}
        </NavLink>
      ))}
    </>
  );
};
